import React from 'react';
import { ModalContent, ModalHeader, Typography } from 'common/components';

export const Guarantee = () => (
  <>
    <ModalHeader title="Надёжные производители " />
    <ModalContent variant="simple">
      <Typography adaptive={false} variant="m" size="body_long">
        Мы&nbsp;работаем только с&nbsp;лидерами рынка. Это значит&nbsp;&mdash; никаких рисков,
        только качественные и&nbsp;проверенные материалы, которые прослужат вам долгие годы.
      </Typography>
    </ModalContent>
  </>
);
